import styled from "styled-components";
import { theme } from "../../../styles/theme";

export const Container = styled.div`
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Map = styled.iframe`
    all: unset;

    width: 100%;
    height: 100%;

    border-radius: 10px;

    @media (max-width: 1068px) {
        height: 300px;
    }
`

export const ContainerContent = styled.div`
    width: 100%;
    height: auto;

    gap: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;

    >img{
        width: 100%;
        height: auto;
        max-width: 80px;
    }

    @media (max-width: 1068px) {
        height: 300px;

        border-radius: 0.75rem;
        background-color: ${theme.colors.white.Branco};
    }
`

export const Loading = styled.div`
  @-webkit-keyframes rotating /* Safari and Chrome */ {
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 50px;
  height: 50px;
  position: relative;
  margin: auto;

  background-color: transparent;
  border-top: 1px solid ${theme.colors.green.Verde_AgroReceita};
  border-bottom:1px solid ${theme.colors.green.Verde_AgroReceita};
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;